import { render } from "./SupplierOrders.vue?vue&type=template&id=06528396&scoped=true"
import script from "./SupplierOrders.vue?vue&type=script&lang=js"
export * from "./SupplierOrders.vue?vue&type=script&lang=js"

import "./SupplierOrders.vue?vue&type=style&index=0&id=06528396&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06528396"]])

export default __exports__